export enum SortOder {
  Ascending = 'asc',
  Descending = 'desc',
  None = 'none',
}
